import { HeldEmailQueuePagination } from "./HeldEmailQueuePagination";
import { HeldEmailQueueViewModel } from "./heldEmailQueueViewModel";

export function HeldEmailQueuePaginationForView({
  model,
}: {
  model: HeldEmailQueueViewModel;
}) {
  return (
    <HeldEmailQueuePagination
      dispatch={model.dispatch}
      page={model.state.page}
      total={model.totalPages}
    />
  );
}
